import React from "react";
import { Modal, Box, CircularProgress } from "@mui/material";

interface Props {
  handleClose: () => void;
}

const LoadingModal: React.FC<Props> = ({ handleClose }) => {
  return (
    <Modal open={true} onClose={handleClose}>
      <Box
        className="relative flex h-full w-full items-center justify-center"
        onClick={handleClose}
      >
        <CircularProgress sx={{ position: "absolute", color: "white" }} />
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{
            color: "#0003",
            position: "absolute",
          }}
        />
      </Box>
    </Modal>
  );
};

export default LoadingModal;
